import React from 'react';

export const OrderQuote = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--orderQuote';
  color = color || '#0076CC';

  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4485_39818)">
        <path
          d="M9.865 20H7.25C6.71957 20 6.21086 19.7893 5.83579 19.4142C5.46071 19.0391 5.25 18.5304 5.25 18V6C5.25 5.46957 5.46071 4.96086 5.83579 4.58579C6.21086 4.21071 6.71957 4 7.25 4H15.25C15.7804 4 16.2891 4.21071 16.6642 4.58579C17.0393 4.96086 17.25 5.46957 17.25 6V14"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 19L16.25 21L20.25 17"
          stroke="#666666"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.25 8H13.25"
          stroke="#666666"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.25 12H11.25"
          stroke="#666666"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4485_39818">
          <rect width="24" height="24" fill="white" transform="translate(0.25)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default OrderQuote;
